import React, { Component } from "react";
import PropTypes from "prop-types";
import ContentPageTagItem from "./ContentPageTagItem";

class ContentPageTagsBlock extends Component {
  render() {
    const { tags } = this.props;
    // console.log("FFFFF:", tags);
    return (
      <div className="row">
        <div className="col-12 col-md-1 pr-md-5 mb-20 mb-md-0">
          <p className="mt-5 mb-0">TAGS:</p>
        </div>
        {tags.map((tag) => (
          <ContentPageTagItem tag={tag} />
        ))}
      </div>
    );
  }
}

ContentPageTagsBlock.propTypes = {};

export default ContentPageTagsBlock;
